import darkLockupUrl from "../../../../brand/topzle-logo-dark-ui.png";
import lightLockupUrl from "../../../../brand/topzle-logo-light-ui.png";
import symbolUrl from "../../../../brand/topzle-symbol-ui.png";

type BrandMarkVariant = "symbol" | "lockup-dark" | "lockup-light";

const sourceByVariant: Record<BrandMarkVariant, string> = {
  symbol: symbolUrl,
  "lockup-dark": darkLockupUrl,
  "lockup-light": lightLockupUrl,
};

export function BrandMark({
  className = "brand-mark",
  variant = "symbol",
  labelled = false,
}: {
  className?: string;
  variant?: BrandMarkVariant;
  labelled?: boolean;
}) {
  return (
    <img
      className={className}
      src={sourceByVariant[variant]}
      alt={labelled ? "Topzle" : ""}
      aria-hidden={labelled ? undefined : "true"}
    />
  );
}
